'use strict'

import HttpClient from './HttpClient'
// import store from '../../store'

class AppInfo extends HttpClient {
  getAllProvince () {
    var url = '/api/app/info/province/all'

    return this.sendGet(url, this.headers)
  }
  getAmphoe (province) {
    var url = '/api/app/info/amphoe/'
    var content = {
      province: province
    }

    return this.sendPost(url, this.headers, content)
  }
}

export default AppInfo
